// prmsOperations disimpan backend sebagai string JSON array. Murni, nol import.

function tryParse(raw) {
  if (typeof raw !== 'string' || raw === '') return undefined;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return undefined;
  }
}

export function parseOperations(raw) {
  const parsed = tryParse(raw);
  return Array.isArray(parsed) ? parsed : [];
}

export function formatOperations(raw) {
  const parsed = tryParse(raw);
  if (Array.isArray(parsed)) return parsed.join(', ');
  return typeof raw === 'string' ? raw : '';
}
